import { useState } from "react";

const ServicePopup = ({ isOpen, serviceId, serviceDetails, onClose, onRegister }) => {
  const [isLoading, setIsLoading] = useState(false);
  if (!isOpen || serviceId === null) return null;

  const handleOverlayClick = () => {
    if (!isLoading) onClose();
  };

  const handlePopupClick = (e) => {
    e.stopPropagation(); 
  };

  const handleRegisterClick = () => {
    setIsLoading(true);
    setTimeout(() => {
      onRegister();
      setIsLoading(false);
    }, 800);
  };

  return (
    <div
      onClick={handleOverlayClick}
      className="fixed inset-0 z-[300] flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-md overflow-y-auto"
    >
      <div
        onClick={handlePopupClick}
        className="relative bg-white w-full max-w-lg rounded-2xl p-6 sm:p-7 shadow-2xl border border-amber-100 transform transition-all animate-in fade-in zoom-in duration-300 my-8"
      >
        {/* Header with Title and Close Button */}
        <div className="flex items-start justify-between gap-4 pb-3 border-b border-gray-100">
          <h2 className="text-lg sm:text-xl font-bold text-gray-900 leading-snug">
            {serviceDetails[serviceId]?.title}
          </h2>

          <button
            onClick={onClose}
            disabled={isLoading}
            className={`text-gray-400 hover:text-gray-600 p-1.5 -mr-1 -mt-1 rounded-lg hover:bg-gray-100 transition-colors shrink-0 ${isLoading ? 'cursor-not-allowed opacity-50' : ''}`}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="pt-2 text-gray-600 font-medium leading-relaxed">
          {serviceDetails[serviceId]?.content}
        </div>

        {/* Footer with Register Button */}
        <div className="mt-6 flex justify-end">
          <button
            onClick={handleRegisterClick}
            disabled={isLoading}
            className={`min-w-[120px] flex items-center justify-center gap-2 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold py-2.5 px-7 rounded-xl transition-all duration-300 shadow-md hover:shadow-lg ${isLoading ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {isLoading ? (
              <>
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                <span>Loading...</span>
              </>
            ) : (
              "Register"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicePopup;